// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageJA = {
  seo: {
    title: 'AIの透明性 | pAIoneer Labs GmbH',
    description: 'pAIoneer Labs GmbHによる人工知能の利用と、それに関する情報提供について：AIアシスタント、AI生成コンテンツの表示、編集上の責任、AI法に基づくお問い合わせ先。',
    keywords: 'AIの透明性, AI法, AI Act, 第50条, 表示, AIアシスタント, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'AIの透明性',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'AIの透明性',
    subtitle: 'pAIoneer Labs GmbHによる人工知能の利用と、それに関する情報提供について。'
  },
  sections: [
    {
      title: '法的枠組み',
      paragraphs: [
        '2026年8月2日以降、人工知能に関する規則（EU）2024/1689（AI法）第50条に基づく透明性義務が適用されています。ドイツでは、KI-Marktüberwachungs- und Innovationsförderungsgesetz（KI-MIG、ドイツのAI市場監視・イノベーション促進法）に基づき、Bundesnetzagentur（ドイツ連邦ネットワーク庁）がAI法の市場監視当局および苦情受付機関となっています。',
        '本ページでは、pAIoneer Labs GmbHが利用しているAIシステムと、それについての情報提供の方法をご説明します。その際に個人データがどのように処理されるかについては、プライバシーポリシーでご説明しています。'
      ]
    },
    {
      title: '当社アプリケーションのAIアシスタント',
      paragraphs: [
        '当社のアプリケーションでは、AIアシスタントがお客様のご質問にお答えします。AIアシスタントはAIシステムです。その回答は言語モデルによって自動的に生成され、誤りを含む可能性があります。重要な情報は、それに基づいて判断を下す前にご確認ください。',
        'アプリケーションは、お客様が最初に入力する前に、またチャットの横に常時、この旨を表示します（AI法第50条第1項）。さらに、アシスタントのすべての回答には、AIによって生成されたものであることが機械可読な形式で表示されています（AI法第50条第2項）。',
        '言語モデルは、OpenRouter, Inc.（米国）のサービスを通じて提供されています。'
      ]
    },
    {
      title: 'AIシステムとの直接のコミュニケーション',
      paragraphs: [
        'pAIoneer Labs GmbHのAIシステムが、たとえばチャットにおいてお客様と直接コミュニケーションを行う場合、遅くとも最初のやり取りの時点で、AIシステムであることを明らかにします。'
      ]
    },
    {
      title: '本ウェブサイトのコンテンツ',
      paragraphs: [
        '本ウェブサイトのテキストは、その作成をAIツールが支援している場合も含め、pAIoneer Labs GmbHが確認し、その編集上の責任のもとで公開しています（AI法第50条第4項第2段落）。',
        'AIを用いて生成または改変された画像・音声・動画コンテンツのうち、実在の人物、場所または出来事を本物と見誤るほど写実的に描写するものについては、人工的に生成または改変されたものであることを表示します（AI法第50条第4項第1段落）。'
      ]
    },
    {
      title: '機械学習による分析',
      paragraphs: [
        'お客様の同意がある場合、当社は機械学習の手法を用いて訪問統計を分析します。詳細はプライバシーポリシーに記載しています。その際、感情認識も生体情報に基づく分類も行いません（AI法第50条第3項）。人間と自動化されたアクセスとの区別は、デバイス、ブラウザおよび接続の技術的特徴に基づいており、生体データには基づいていません。'
      ]
    },
    {
      title: '苦情の申立て',
      paragraphs: [
        'お客様は、AI法への違反の可能性について、ドイツにおけるAI法の市場監視当局および苦情受付機関であるBundesnetzagenturに苦情を申し立てることができます。これに関する情報は、同庁がbundesnetzagentur.de/kiで提供しています。'
      ]
    }
  ],
  contact: {
    title: 'お問い合わせ',
    description: '人工知能の利用に関するご質問は、メールでご連絡ください。',
    email: 'info@paioneer.eu'
  },
  lastUpdated: '2026年10月30日現在。ドイツ語版が正本となります。'
};
